import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useForm } from "../../hooks/useForm";
import { startLogin } from "../../redux/actions/auth";

import "./login.css";
import logoPretzu from "../../assets/logos_pretzu/logo_login.svg";
import loginLinea from "./login_linea.svg";

export const Login = () => {
  const dispatch = useDispatch();

  const [formLoginValues, handleLoginInputChange] = useForm();
  const { email, password } = formLoginValues;

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(startLogin(email, password));
  };

  return (
    <div className="container">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        limit={1}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div className="row flex justify-content-center ContainerLogin">
        <div className="col-md-6">
          <div className="row text-center mt-3">
            <div className="col flex justify-content-center">
              <img src={logoPretzu} alt="logo pretzu" />
            </div>
          </div>

          <div className="row">
            <div className="col text-center">
              <h1 className="p-text-iniciar">Iniciar sesión</h1>
            </div>
          </div>

          <form className="login mt-5" onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Correo electrónico o usuario
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                id="loginEmail"
                placeholder="Ingresa tu correo o usuario"
                value={email || ""}
                onChange={handleLoginInputChange}
              />
            </div>
            <div className="mb-3 mt-3">
              <label htmlFor="exampleInputPassword1" className="form-label">
                Contraseña
              </label>
              <input
                type="password"
                name="password"
                className="form-control"
                id="loginPassword"
                placeholder="Ingresa tu contraseña"
                value={password || ""}
                onChange={handleLoginInputChange}
              />
            </div>

            <button
              type="submit"
              className={email && password ? "btn mt-3" : "btn disabled mt-3"}
            >
              Iniciar sesión
            </button>
          </form>

          <div className="flex justify-content-center mt-4">
            <img src={loginLinea} alt="linea" />
          </div>

          <div className="row mt-4 text-center">
            <div className="col">
              <Link to="/password/reset" className="p-olvidaste-clave">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
          </div>

          <div className="row mt-4 text-center">
            <div className="col p-no-registrado">
              ¿No tienes una cuenta?{" "}
              <Link to="/onboarding" className="p-registrate">
                Crear una cuenta
              </Link>
              {/* <a
                href="https://wa.me/51968503246?text=Hola%2C%20quiero%20probar%20Pretzu%20y%20crear%20mi%20primer%20proyecto"
                target="_blank"
                className="p-registrate"
                rel="noreferrer"
              >
                Solicitar una cuenta
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
